/* PDP Stack — product page behaviour. No dependencies. Every hook uses data-ps-* attributes. */
(function () {
  'use strict';
  if (window.PSStackLoaded) return;
  window.PSStackLoaded = true;
  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    const fmt = format || '${{amount}}';
    const m = fmt.match(/\{\{\s*(\w+)\s*\}\}/);
    const kind = m ? m[1] : 'amount';
    const n = Number(cents) / 100;
    const withDelims = (num, dec, thou, decSep) => {
      const parts = num.toFixed(dec).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thou);
      return parts.join(decSep);
    };
    let value;
    switch (kind) {
      case 'amount_no_decimals': value = withDelims(n, 0, ',', '.'); break;
      case 'amount_with_comma_separator': value = withDelims(n, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = withDelims(n, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': value = withDelims(n, 2, "'", '.'); break;
      default: value = withDelims(n, 2, ',', '.');
    }
    return fmt.replace(/\{\{\s*\w+\s*\}\}/, value);
  }

  /* ---------- gallery ---------- */
  function initGallery(el) {
    const track = el.querySelector('[data-ps-gallery-track]');
    const thumbs = el.querySelectorAll('[data-ps-thumb]');
    const dots = el.querySelectorAll('[data-ps-dot]');
    if (!track) return;
    const go = (i, smooth = true) => {
      const slide = track.children[i];
      if (slide) track.scrollTo({ left: slide.offsetLeft - track.offsetLeft, behavior: smooth ? 'smooth' : 'auto' });
    };
    const prev = el.querySelector('[data-ps-gallery-prev]'), next = el.querySelector('[data-ps-gallery-next]');
    const cur = () => Math.round(track.scrollLeft / (track.clientWidth || 1));
    const sync = () => {
      const i = cur(), n = track.children.length;
      thumbs.forEach((t, j) => t.setAttribute('aria-current', j === i ? 'true' : 'false'));
      dots.forEach((d, j) => d.classList.toggle('on', j === i));
      if (prev) prev.disabled = i <= 0;
      if (next) next.disabled = i >= n - 1;
    };
    thumbs.forEach((t) => t.addEventListener('click', () => go(Number(t.dataset.psThumb))));
    if (prev) prev.addEventListener('click', () => go(Math.max(0, cur() - 1)));
    if (next) next.addEventListener('click', () => go(Math.min(track.children.length - 1, cur() + 1)));
    let raf;
    track.addEventListener('scroll', () => {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(sync);
    });
    el.psGoToMedia = (mediaId) => {
      const idx = [...track.children].findIndex((c) => c.dataset.mediaId === String(mediaId));
      if (idx > -1) go(idx);
    };
  }

  /* ---------- product controller ---------- */
  function initProduct(rootEl) {
    const jsonEl = rootEl.querySelector('[data-ps-product-json]');
    if (!jsonEl) return;
    const product = JSON.parse(jsonEl.textContent);
    const moneyFormat = rootEl.dataset.moneyFormat;
    const form = rootEl.querySelector('[data-ps-form]');
    const idInput = form && form.querySelector('input[name="id"]');
    const qtyInput = form && form.querySelector('input[name="quantity"]');
    const planInput = form && form.querySelector('input[name="selling_plan"]');
    const atc = rootEl.querySelector('[data-ps-atc]');
    const atcLabel = atc && atc.querySelector('[data-ps-atc-label]');
    const atcPrice = atc && atc.querySelector('[data-ps-atc-price]');
    const errorEl = rootEl.querySelector('[data-ps-error]');
    const gallery = document.querySelector('[data-ps-gallery]');
    const state = {
      variant: product.variants.find((v) => String(v.id) === String(idInput && idInput.value)) || product.variants[0],
      tier: null,
      plan: planInput ? planInput.value : '',
    };

    const optionInputs = rootEl.querySelectorAll('[data-ps-option]');
    const tiers = [...rootEl.querySelectorAll('[data-ps-tier]')];
    const plans = [...rootEl.querySelectorAll('[data-ps-plan]')];
    const gifts = [...rootEl.querySelectorAll('[data-ps-gift]')];

    const selectedOptions = () => {
      const vals = [];
      product.options.forEach((_, i) => {
        const checked = rootEl.querySelector(`[data-ps-option="${i}"]:checked`) || rootEl.querySelector(`select[data-ps-option="${i}"]`);
        vals[i] = checked ? checked.value : state.variant.options[i];
      });
      return vals;
    };
    const findVariant = (vals) => product.variants.find((v) => v.options.every((o, i) => o === vals[i]));
    const matchVariant = (text) => {
      const t = text.toLowerCase();
      return product.variants.find((v) => v.title.toLowerCase().includes(t));
    };
    const unitPrice = (variant) => {
      if (state.plan) {
        const alloc = (variant.selling_plan_allocations || []).find((a) => String(a.selling_plan_id) === String(state.plan));
        if (alloc) return alloc.price;
      }
      return variant.price;
    };

    function markUnavailable() {
      const current = selectedOptions();
      optionInputs.forEach((input) => {
        if (input.tagName === 'SELECT') return;
        const i = Number(input.dataset.psOption);
        const test = current.slice();
        test[i] = input.value;
        const v = findVariant(test);
        input.classList.toggle('is-unavailable', !v || !v.available);
      });
    }

    function tierVariant(tier) {
      if (!tier) return state.variant;
      if (tier.dataset.variantId) { const v = product.variants.find((x) => String(x.id) === tier.dataset.variantId); if (v) return v; }
      const m = tier.dataset.variantMatch;
      if (m) return matchVariant(m) || state.variant;
      return state.variant;
    }

    // Tier total for q units at unit price `each` (plan-adjusted) where `base` is the one-time unit price.
    // Mirrors the store's real deal: fixed bundle price (scaled by the plan saving), free units or % off,
    // optionally only on one-time orders.
    function tierTotal(t, each, q, base) {
      if (!t) return each * q;
      const sub = base && each < base;
      if (sub && t.dataset.oneTimeOnly === 'true') return each * q;
      const fixed = Number(t.dataset.fixedPrice || 0);
      if (fixed > 0) return sub ? Math.round(fixed * (each / base)) : fixed;
      const free = Math.min(q - 1, Math.max(0, Number(t.dataset.freeUnits || 0)));
      return Math.round(each * (q - free) * (1 - Number(t.dataset.discount || 0) / 100));
    }

    const appDriven = !tiers.length && !!rootEl.querySelector('[data-ps-app-block]');

    function render() {
      const tier = state.tier;
      const variant = tierVariant(tier);
      const qty = tier ? (tier.dataset.variantId ? 1 : Math.max(1, Number(tier.dataset.qty || 1))) : 1;
      const discount = tier ? Number(tier.dataset.discount || 0) : 0;
      if (idInput) idInput.value = variant.id;
      if (qtyInput && !appDriven) qtyInput.value = qty;
      if (planInput) planInput.value = state.plan || '';

      const each = unitPrice(variant);
      const total = tierTotal(tier, each, qty, variant.price);
      const compareEach = Math.max(variant.compare_at_price || 0, variant.price);
      const compareTotal = compareEach * qty;

      rootEl.querySelectorAll('[data-ps-price]').forEach((el) => (el.textContent = formatMoney(total, moneyFormat)));
      rootEl.querySelectorAll('[data-ps-compare]').forEach((el) => {
        el.textContent = compareTotal > total ? formatMoney(compareTotal, moneyFormat) : '';
        el.hidden = !(compareTotal > total);
      });
      rootEl.querySelectorAll('[data-ps-save]').forEach((el) => {
        const save = compareTotal - total;
        el.hidden = !(save > 0);
        if (save > 0) el.textContent = (el.dataset.template || 'Save [amount]').replace('[amount]', formatMoney(save, moneyFormat)).replace('[percent]', Math.round((save / compareTotal) * 100) + '%');
      });

      tiers.forEach((t) => {
        const tv = tierVariant(t);
        const q = t.dataset.variantId ? 1 : Math.max(1, Number(t.dataset.qty || 1));
        const d = Number(t.dataset.discount || 0);
        const tt = tierTotal(t, unitPrice(tv), q, tv.price);
        const tc = Math.max(tv.compare_at_price || 0, tv.price) * q;
        const units = q * Math.max(1, Number(t.dataset.unitsPerQty || 1));
        const set = (sel, txt) => { const el = t.querySelector(sel); if (el) { el.textContent = txt; el.hidden = !txt; } };
        set('[data-ps-tier-price]', formatMoney(tt, moneyFormat));
        set('[data-ps-tier-compare]', tc > tt ? formatMoney(tc, moneyFormat) : '');
        set('[data-ps-tier-unit]', (t.dataset.unitLabel ? formatMoney(Math.round(tt / units), moneyFormat) + ' ' + t.dataset.unitLabel : ''));
        const saveEl = t.querySelector('[data-ps-tier-save]');
        if (saveEl) { const s = tc - tt; saveEl.hidden = !(s > 0); if (s > 0) saveEl.textContent = (saveEl.dataset.template || 'Save [amount]').replace('[amount]', formatMoney(s, moneyFormat)).replace('[percent]', Math.round((s / tc) * 100) + '%'); }
        const ti = tiers.indexOf(t) + 1;
        document.querySelectorAll('[data-ps-offer-price="' + ti + '"]').forEach((el) => (el.textContent = formatMoney(tt, moneyFormat)));
        document.querySelectorAll('[data-ps-offer-compare="' + ti + '"]').forEach((el) => { el.textContent = tc > tt ? formatMoney(tc, moneyFormat) : ''; el.hidden = !(tc > tt); });
        t.classList.toggle('is-selected', t === tier);
        const input = t.querySelector('input');
        if (input) input.checked = t === tier;
      });

      const tierIndex = tier ? tiers.indexOf(tier) + 1 : 1;
      gifts.forEach((g) => {
        const locked = tierIndex < Number(g.dataset.unlockTier || 1);
        g.classList.toggle('is-locked', locked);
        const s = g.querySelector('[data-ps-gift-state]');
        if (s) s.textContent = locked ? (g.dataset.lockedLabel || 'Locked') : (g.dataset.unlockedLabel || 'Unlocked');
      });

      plans.forEach((p) => {
        const input = p.querySelector('input');
        p.classList.toggle('is-selected', input && input.value === (state.plan || ''));
        if (input) input.checked = input.value === (state.plan || '');
        const priceEl = p.querySelector('[data-ps-plan-price]');
        const pricesWrap = p.querySelector('.ps-plan__prices');
        if (pricesWrap) pricesWrap.hidden = appDriven;
        if (priceEl) {
          let pp = variant.price;
          if (input && input.value) {
            const a = (variant.selling_plan_allocations || []).find((x) => String(x.selling_plan_id) === input.value);
            if (a) pp = a.price;
          }
          priceEl.textContent = formatMoney(tierTotal(tier, pp, qty, variant.price), moneyFormat);
          // Note shown when the selected tier's volume deal only applies to one-time orders.
          const dealTier = !!(tier && (Number(tier.dataset.fixedPrice || 0) > 0 || Number(tier.dataset.freeUnits || 0) > 0 || Number(tier.dataset.discount || 0) > 0));
          const fixedEl = p.querySelector('[data-ps-plan-fixed]');
          if (fixedEl) fixedEl.hidden = !(dealTier && tier.dataset.oneTimeOnly === 'true');
          const cmpEl = p.querySelector('[data-ps-plan-compare]');
          if (cmpEl) { const full = tierTotal(tier, variant.price, qty, variant.price), subT = tierTotal(tier, pp, qty, variant.price); cmpEl.textContent = input && input.value && full > subT ? formatMoney(full, moneyFormat) : ''; }
        }
      });

      if (atc) {
        atc.disabled = !variant.available;
        if (atcLabel) atcLabel.textContent = variant.available ? atc.dataset.labelAdd : atc.dataset.labelSoldout;
        if (atcPrice) {
          atcPrice.innerHTML = '';
          if (variant.available && atc.dataset.showPrice === 'true') {
            if (compareTotal > total) { const s = document.createElement('s'); s.textContent = formatMoney(compareTotal, moneyFormat); atcPrice.appendChild(s); atcPrice.append(' '); }
            atcPrice.append(formatMoney(total, moneyFormat));
          }
        }
      }
      document.querySelectorAll('[data-ps-sticky-price]').forEach((el) => { el.textContent = formatMoney(total, moneyFormat); el.hidden = appDriven; });
      markUnavailable();
    }

    optionInputs.forEach((input) =>
      input.addEventListener('change', () => {
        const v = findVariant(selectedOptions());
        if (v) {
          state.variant = v;
          if (v.featured_media && gallery && gallery.psGoToMedia) gallery.psGoToMedia(v.featured_media.id);
          const url = new URL(window.location.href);
          url.searchParams.set('variant', v.id);
          window.history.replaceState({}, '', url.toString());
        }
        render();
      })
    );
    tiers.forEach((t) => {
      t.addEventListener('click', () => { state.tier = t; render(); });
      const input = t.querySelector('input');
      if (input) input.addEventListener('change', () => { state.tier = t; render(); });
    });
    plans.forEach((p) => {
      const input = p.querySelector('input');
      if (input) input.addEventListener('change', () => { state.plan = input.type === 'checkbox' ? (input.checked ? input.value : '') : input.value; render(); });
    });
    state.tier = tiers.find((t) => t.dataset.default === 'true') || tiers[0] || null;
    const defaultPlan = plans.find((p) => p.dataset.default === 'true');
    if (defaultPlan) { state.plan = defaultPlan.querySelector('input').value; }

    /* external selection: offer cards, shade guide */
    document.addEventListener('ps:select-tier', (e) => {
      const t = tiers[Number(e.detail.index)];
      if (t) { state.tier = t; render(); }
    });
    document.addEventListener('ps:select-option', (e) => {
      const { name, value } = e.detail;
      const i = product.options.findIndex((o) => o.toLowerCase() === String(name).toLowerCase());
      if (i < 0) return;
      const input = [...rootEl.querySelectorAll(`[data-ps-option="${i}"]`)].find((x) => x.value.toLowerCase() === String(value).toLowerCase());
      if (input) { if (input.tagName === 'SELECT') input.value = input.value; else input.checked = true; input.dispatchEvent(new Event('change', { bubbles: true })); }
    });

    /* add to cart */
    if (form) {
      form.addEventListener('submit', async (e) => {
        e.preventDefault();
        if (errorEl) errorEl.hidden = true;
        const variant = tierVariant(state.tier);
        const qty = Number(qtyInput ? qtyInput.value : 1) || 1;
        let items = [{ id: variant.id, quantity: qty }];
        if (state.plan) items[0].selling_plan = Number(state.plan);
        if (appDriven) {
          // Bundle apps write quantity / selling plan / variant into the product form; submit exactly what they set.
          const fd = new FormData(form);
          items = [{ id: Number(fd.get('id')) || variant.id, quantity: Math.max(1, Number(fd.get('quantity')) || 1) }];
          const sp = fd.get('selling_plan');
          if (sp) items[0].selling_plan = Number(sp);
        }
        const giftId = state.tier && state.tier.dataset.giftVariant;
        if (giftId) items.push({ id: Number(giftId), quantity: 1, properties: { _ps_gift: 'true' } });
        rootEl.querySelectorAll('[data-ps-addon]:checked').forEach((cb) => items.push({ id: Number(cb.value), quantity: 1 }));
        atc.disabled = true;
        atc.setAttribute('aria-busy', 'true');
        try {
          const res = await fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items }) });
          const data = await res.json();
          if (!res.ok) throw new Error(data.description || data.message || 'Could not add to cart');
          document.dispatchEvent(new CustomEvent('ps:added', { detail: data }));
          const after = rootEl.dataset.afterAdd || 'cart';
          if (after === 'checkout') window.location.href = root + 'checkout';
          else if (after === 'cart') window.location.href = root + 'cart';
          else { atc.disabled = false; atc.removeAttribute('aria-busy'); refreshCartCount(); }
        } catch (err) {
          if (errorEl) { errorEl.textContent = err.message; errorEl.hidden = false; }
          atc.disabled = false;
          atc.removeAttribute('aria-busy');
        }
      });
    }
    render();
  }

  async function refreshCartCount() {
    try {
      const cart = await (await fetch(root + 'cart.js')).json();
      document.querySelectorAll('[data-ps-cart-count]').forEach((el) => (el.textContent = cart.item_count));
    } catch (e) { /* non-critical */ }
  }

  /* ---------- delivery estimate ---------- */
  function initDelivery(el) {
    const min = Number(el.dataset.min || 3), max = Number(el.dataset.max || 5), cutoff = Number(el.dataset.cutoff || 14);
    const skipWeekends = el.dataset.skipWeekends === 'true';
    const addDays = (d, n) => { const x = new Date(d); let added = 0; while (added < n) { x.setDate(x.getDate() + 1); if (!skipWeekends || (x.getDay() !== 0 && x.getDay() !== 6)) added++; } return x; };
    const tick = () => {
      const now = new Date();
      let start = new Date(now);
      if (now.getHours() >= cutoff) start.setDate(start.getDate() + 1);
      const fmt = (d) => d.toLocaleDateString(undefined, { weekday: 'short', month: 'short', day: 'numeric' });
      const a = addDays(start, min), b = addDays(start, max);
      const cut = new Date(now); cut.setHours(cutoff, 0, 0, 0); if (now >= cut) cut.setDate(cut.getDate() + 1);
      const mins = Math.max(0, Math.round((cut - now) / 60000));
      const h = Math.floor(mins / 60), m = mins % 60;
      const tpl = el.dataset.template || 'Order within [time] for delivery [dates]';
      el.querySelector('[data-ps-delivery-text]').textContent = tpl.replace('[time]', `${h}h ${m}m`).replace('[dates]', min === max ? `by ${fmt(a)}` : `${fmt(a)} – ${fmt(b)}`);
    };
    tick(); setInterval(tick, 60000);
  }

  /* ---------- countdown to a real end date ---------- */
  function initCountdown(el) {
    const end = new Date(el.dataset.end);
    if (isNaN(end)) { el.hidden = true; return; }
    const out = el.querySelector('[data-ps-countdown-time]');
    const tick = () => {
      const ms = end - new Date();
      if (ms <= 0) { el.hidden = true; return false; }
      const s = Math.floor(ms / 1000), d = Math.floor(s / 86400), h = Math.floor((s % 86400) / 3600), m = Math.floor((s % 3600) / 60), sec = s % 60;
      const p = (n) => String(n).padStart(2, '0');
      if (el.dataset.format === 'boxes') {
        const set = (k, v) => { const b = el.querySelector('[data-ps-cd="' + k + '"]'); if (b) b.textContent = p(v); };
        set('h', d * 24 + h); set('m', m); set('s', sec);
      } else {
        out.textContent = (d ? d + 'd ' : '') + `${p(h)}:${p(m)}:${p(sec)}`;
      }
      return true;
    };
    if (tick()) { const t = setInterval(() => { if (!tick()) clearInterval(t); }, 1000); }
  }

  /* ---------- count-up numbers (final value is in the HTML; animates only when scrolled into view) ---------- */
  function initCountUp(el) {
    const m = el.textContent.trim().match(/^(\D*)([\d,.]+)(.*)$/);
    if (!m || !('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    const [, pre, numStr, post] = m, target = parseFloat(numStr.replace(/,/g, '')), dec = (numStr.split('.')[1] || '').length, comma = numStr.includes(',');
    if (!isFinite(target)) return;
    const fmt = (v) => { const t = v.toFixed(dec); return comma ? Number(t).toLocaleString('en-US', { minimumFractionDigits: dec }) : t; };
    const io = new IntersectionObserver((entries) => {
      if (!entries[0].isIntersecting) return;
      io.disconnect();
      const t0 = performance.now(), dur = 1400;
      const step = (now) => { const k = Math.min(1, (now - t0) / dur), e = 1 - Math.pow(1 - k, 3); el.textContent = pre + fmt(target * e) + post; if (k < 1) requestAnimationFrame(step); };
      requestAnimationFrame(step);
    }, { threshold: 0.4 });
    io.observe(el);
  }

  /* ---------- slider arrows for horizontal rails ---------- */
  function initRail(wrap) {
    const rail = wrap.querySelector('[data-ps-rail]');
    if (!rail) return;
    const by = (dir) => { const card = rail.firstElementChild; const w = card ? card.getBoundingClientRect().width + 16 : rail.clientWidth * 0.8; rail.scrollBy({ left: dir * w, behavior: 'smooth' }); };
    const prev = wrap.querySelector('[data-ps-rail-prev]'), next = wrap.querySelector('[data-ps-rail-next]');
    if (prev) prev.addEventListener('click', () => by(-1));
    if (next) next.addEventListener('click', () => by(1));
  }

  /* ---------- slideshow ---------- */
  function initUgcDots(wrap) {
    const rail = wrap.querySelector('[data-ps-rail]'), dots = wrap.querySelector('[data-ps-ugcr-dots]');
    if (!rail || !dots) return;
    const pages = () => Math.max(1, Math.round((rail.scrollWidth - rail.clientWidth) / rail.clientWidth) + 1);
    const draw = () => {
      const n = pages(); dots.innerHTML = '';
      for (let i = 0; i < n; i++) { const b = document.createElement('button'); b.type = 'button'; b.setAttribute('aria-label', 'Go to reviews ' + (i + 1)); b.addEventListener('click', () => rail.scrollTo({ left: i * rail.clientWidth, behavior: 'smooth' })); dots.appendChild(b); }
      mark();
    };
    const mark = () => {
      const max = rail.scrollWidth - rail.clientWidth, n = dots.children.length;
      const i = max > 0 ? Math.round((rail.scrollLeft / max) * (n - 1)) : 0;
      Array.from(dots.children).forEach((b, k) => b.setAttribute('aria-current', k === i ? 'true' : 'false'));
    };
    let t = 0;
    rail.addEventListener('scroll', () => { if (!t) t = setTimeout(() => { t = 0; mark(); }, 80); }, { passive: true });
    window.addEventListener('resize', draw);
    draw();
  }
  function initSlideshow(el) {
    const track = el.querySelector('[data-ps-ss-track]');
    if (!track) return;
    const slides = [...track.children];
    const dots = [...el.querySelectorAll('[data-ps-ss-dot]')];
    const current = () => Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
    const go = (i) => {
      const n = (i + slides.length) % slides.length, left = n * track.clientWidth;
      track.scrollTo({ left, behavior: 'smooth' });
      // fallback where smooth scrolling is unavailable or paused
      setTimeout(() => { if (Math.abs(track.scrollLeft - left) > 4) { track.style.scrollBehavior = 'auto'; track.scrollLeft = left; track.style.scrollBehavior = ''; } mark(); }, 650);
    };
    const mobile = window.matchMedia('(max-width: 749px)');
    const fit = () => { const c = current(); track.style.height = mobile.matches && slides[c] ? slides[c].offsetHeight + 'px' : ''; };
    const mark = () => { const c = current(); dots.forEach((d, i) => d.setAttribute('aria-current', i === c ? 'true' : 'false')); fit(); };
    window.addEventListener('resize', fit);
    el.querySelectorAll('img').forEach((im) => { if (!im.complete) im.addEventListener('load', fit, { once: true }); });
    let sT; track.addEventListener('scroll', () => { clearTimeout(sT); sT = setTimeout(mark, 120); }, { passive: true }); mark();
    dots.forEach((d, i) => d.addEventListener('click', () => { go(i); stop(); }));
    const prev = el.querySelector('[data-ps-ss-prev]'), next = el.querySelector('[data-ps-ss-next]');
    if (prev) prev.addEventListener('click', () => { go(current() - 1); stop(); });
    if (next) next.addEventListener('click', () => { go(current() + 1); stop(); });
    let timer = null, paused = false;
    const stop = () => { if (timer) { clearInterval(timer); timer = null; } };
    const start = () => {
      if (el.dataset.autoplay !== 'true' || slides.length < 2 || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      stop(); timer = setInterval(() => { if (!paused && !document.hidden) go(current() + 1); }, Math.max(3, Number(el.dataset.interval || 5)) * 1000);
    };
    el.addEventListener('mouseenter', () => (paused = true)); el.addEventListener('mouseleave', () => (paused = false));
    el.addEventListener('focusin', () => (paused = true)); el.addEventListener('focusout', () => (paused = false));
    track.addEventListener('touchstart', stop, { passive: true });
    start();
    document.addEventListener('shopify:block:select', (e) => { const i = slides.indexOf(e.target); if (i > -1) { stop(); go(i); } });
  }

  /* ---------- before/after ---------- */
  function initBeforeAfter(el) {
    const input = el.querySelector('input[type="range"]');
    if (!input) return;
    const set = () => el.style.setProperty('--pos', input.value + '%');
    input.addEventListener('input', set); set();
  }

  /* ---------- sticky add to cart ---------- */
  function initSticky(el) {
    const target = document.querySelector('[data-ps-atc]');
    if (!target || !('IntersectionObserver' in window)) return;
    const io = new IntersectionObserver(([entry]) => {
      const below = entry.boundingClientRect.top < 0;
      el.classList.toggle('is-visible', !entry.isIntersecting && below);
      el.setAttribute('aria-hidden', entry.isIntersecting || !below ? 'true' : 'false');
    });
    io.observe(target);
    el.querySelector('[data-ps-sticky-btn]').addEventListener('click', () => {
      const box = document.querySelector('[data-ps-buybox]') || target;
      box.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  }

  /* ---------- offer cards + shade guide talk to the product section ---------- */
  document.addEventListener('click', (e) => {
    const tierBtn = e.target.closest('[data-ps-pick-tier]');
    if (tierBtn && document.querySelector('[data-ps-tier]')) {
      e.preventDefault();
      document.dispatchEvent(new CustomEvent('ps:select-tier', { detail: { index: tierBtn.dataset.psPickTier } }));
      (document.querySelector('[data-ps-buybox]') || document.body).scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
    const optBtn = e.target.closest('[data-ps-pick-option]');
    if (optBtn) {
      document.querySelectorAll('[data-ps-pick-option]').forEach((b) => b.classList.toggle('is-selected', b === optBtn));
      document.dispatchEvent(new CustomEvent('ps:select-option', { detail: { name: optBtn.dataset.optionName, value: optBtn.dataset.psPickOption } }));
    }
  });


  /* Scroll reveal: one observer; only content below the fold at load animates, so nothing on first paint is delayed */
  const RV_GROUPS = '.ps-grid,.ps-stats,.ps-rail,.ps-track,.ps-offer-cards,.ps-swatches,.ps-logos,.ps-compare-layout,.ps-split';
  const RV_SINGLES = '.ps-section__head,.ps-guarantee,.ps-faq,.ps-expert,.ps-compare-wrap,.ps-banner__content,.ps-ba';
  const RV_SKIP = '.ps-pdp,[data-ps-slideshow],.ps-sticky-atc,.ps-marquee,.ps-product-grid-skip';
  let rvIO = null;
  function revealDone(el) {
    el.classList.add('is-in');
    setTimeout(() => {
      el.classList.remove('ps-rv', 'ps-rvg', 'is-in');
      [el, ...el.children].forEach((c) => c.style.removeProperty('--i'));
    }, 1600);
  }
  /* backstop: if an observer callback is ever missed, reveal anything that has reached the viewport on scroll */
  let rvTick = 0;
  function rvSweep() {
    rvTick = 0;
    document.querySelectorAll('.ps-rv:not(.is-in),.ps-rvg:not(.is-in)').forEach((el) => {
      if (el.getBoundingClientRect().top < window.innerHeight) { if (rvIO) rvIO.unobserve(el); revealDone(el); }
    });
  }
  window.addEventListener('scroll', () => { if (!rvTick) rvTick = setTimeout(rvSweep, 200); }, { passive: true });
  function initReveal(scope) {
    const root = document.documentElement;
    if (!root.classList.contains('ps-anim') || !('IntersectionObserver' in window)) return;
    if (!rvIO) rvIO = new IntersectionObserver((entries) => {
      entries.forEach((e) => { if (e.isIntersecting) { rvIO.unobserve(e.target); revealDone(e.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.01 });
    const fold = window.innerHeight * 0.92;
    const below = (el) => el.getBoundingClientRect().top > fold;
    scope.querySelectorAll(RV_GROUPS).forEach((g) => {
      if (g.closest(RV_SKIP) || g.closest('.ps-rvg') || !below(g)) return;
      g.classList.add('ps-rvg');
      Array.from(g.children).forEach((c, i) => c.style.setProperty('--i', Math.min(i, 6)));
      rvIO.observe(g);
    });
    scope.querySelectorAll(RV_SINGLES).forEach((el) => {
      if (el.closest(RV_SKIP) || el.closest('.ps-rvg') || el.querySelector('.ps-rvg') && !el.matches('.ps-section__head') || !below(el)) return;
      el.classList.add('ps-rv');
      rvIO.observe(el);
    });
  }

  function boot(scope) {
    scope.querySelectorAll('[data-ps-gallery]').forEach(initGallery);
    scope.querySelectorAll('[data-ps-product]').forEach(initProduct);
    scope.querySelectorAll('[data-ps-delivery]').forEach(initDelivery);
    scope.querySelectorAll('[data-ps-countdown]').forEach(initCountdown);
    scope.querySelectorAll('[data-ps-ba]').forEach(initBeforeAfter);
    scope.querySelectorAll('[data-ps-count]').forEach(initCountUp);
    scope.querySelectorAll('.ps-rail-wrap').forEach(initRail);
    scope.querySelectorAll('[data-ps-ugcr]').forEach(initUgcDots);
    scope.querySelectorAll('[data-ps-slideshow]').forEach(initSlideshow);
    scope.querySelectorAll('[data-ps-sticky]').forEach(initSticky);
    initReveal(scope);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => boot(document));
  else boot(document);
  /* re-init sections when edited in the theme editor */
  document.addEventListener('shopify:section:load', (e) => boot(e.target));
})();
